"use client";

import { c as _c } from "react/compiler-runtime";
import { Close } from "@mui/icons-material";
import { Fade, Modal } from "@mui/material";
import React from "react";
import styled, { useTheme } from "styled-components";
const ModalComponent = t0 => {
  const $ = _c(31);
  const {
    children,
    open,
    onClose,
    blockClose: t1,
    minHeight: t2,
    minWidth: t3,
    hiddenCloseButton: t4,
    noPadding: t5,
    fullPageMobile: t6,
    modalBoxStyles,
    bottomSticked: t7,
    background: t8,
    fullSpaceModal: t9
  } = t0;
  const blockClose = t1 === undefined ? false : t1;
  const minHeight = t2 === undefined ? "270px" : t2;
  const minWidth = t3 === undefined ? "430px" : t3;
  const hiddenCloseButton = t4 === undefined ? false : t4;
  const noPadding = t5 === undefined ? false : t5;
  const fullPageMobile = t6 === undefined ? false : t6;
  const bottomSticked = t7 === undefined ? false : t7;
  const background = t8 === undefined ? true : t8;
  const fullSpaceModal = t9 === undefined ? false : t9;
  const theme = useTheme();
  let t10;
  if ($[0] !== blockClose || $[1] !== onClose) {
    t10 = () => {
      if (!blockClose) {
        onClose(false);
      }
    };
    $[0] = blockClose;
    $[1] = onClose;
    $[2] = t10;
  } else {
    t10 = $[2];
  }
  const t11 = background ? `${theme.colors.GRAYSCALE_100}100` : "rgba(0, 0, 0, 0.5)";
  let t12;
  if ($[3] !== t11) {
    t12 = {
      backdrop: {
        sx: {
          backgroundColor: t11
        }
      }
    };
    $[3] = t11;
    $[4] = t12;
  } else {
    t12 = $[4];
  }
  let t13;
  if ($[5] !== blockClose || $[6] !== fullSpaceModal || $[7] !== hiddenCloseButton || $[8] !== onClose) {
    t13 = !hiddenCloseButton && !blockClose && <CloseIconWrapper $fullSpaceModal={fullSpaceModal}><CloseIconBackground onClick={() => onClose(false)}><Close width={12} height={12} /></CloseIconBackground></CloseIconWrapper>;
    $[5] = blockClose;
    $[6] = fullSpaceModal;
    $[7] = hiddenCloseButton;
    $[8] = onClose;
    $[9] = t13;
  } else {
    t13 = $[9];
  }
  let t14;
  if ($[10] !== children || $[11] !== fullSpaceModal || $[12] !== t13) {
    t14 = <ContentWrapper $fullSpaceModal={fullSpaceModal}>{t13}{children}</ContentWrapper>;
    $[10] = children;
    $[11] = fullSpaceModal;
    $[12] = t13;
    $[13] = t14;
  } else {
    t14 = $[13];
  }
  let t15;
  if ($[14] !== bottomSticked || $[15] !== fullPageMobile || $[16] !== fullSpaceModal || $[17] !== minHeight || $[18] !== minWidth || $[19] !== modalBoxStyles || $[20] !== noPadding || $[21] !== t14) {
    t15 = <ModalBox $fullPageMobile={fullPageMobile} $minHeight={minHeight} $minWidth={minWidth} $noPadding={noPadding} style={modalBoxStyles} $bottomSticked={bottomSticked} className="modal-box" $fullSpaceModal={fullSpaceModal}>{t14}</ModalBox>;
    $[14] = bottomSticked;
    $[15] = fullPageMobile;
    $[16] = fullSpaceModal;
    $[17] = minHeight;
    $[18] = minWidth;
    $[19] = modalBoxStyles;
    $[20] = noPadding;
    $[21] = t14;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== open || $[24] !== t15) {
    t16 = <Fade in={open}>{t15}</Fade>;
    $[23] = open;
    $[24] = t15;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== open || $[27] !== t10 || $[28] !== t12 || $[29] !== t16) {
    t17 = <Modal aria-labelledby="transition-modal-title" aria-describedby="transition-modal-description" open={open} onClose={t10} closeAfterTransition={true} slotProps={t12}>{t16}</Modal>;
    $[26] = open;
    $[27] = t10;
    $[28] = t12;
    $[29] = t16;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  return t17;
};
const CloseIconBackground = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  background-color: ${({
  theme
}) => theme.colors.GRAYSCALE_100};
  border-radius: ${({
  theme
}) => theme.radii.circle};
  cursor: pointer;

  ${({
  theme
}) => theme.mediaQueries.sm} {
    background-color: transparent;
  }
`;
const CloseIconWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
  position: absolute;
  top: -20px;
  right: -20px;

  ${({
  theme
}) => theme.mediaQueries.sm} {
    top: ${({
  $fullSpaceModal
}) => $fullSpaceModal ? "20px" : "0"};
    right: ${({
  $fullSpaceModal
}) => $fullSpaceModal ? "20px" : "0"};
  }

  ${({
  $fullSpaceModal
}) => $fullSpaceModal && `
    top: 20px;
    right: 20px;
  `}
`;
const ContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  padding: ${({
  $fullSpaceModal
}) => $fullSpaceModal ? "0" : "50px"};

  ${({
  theme
}) => theme.mediaQueries.sm} {
    z-index: 1;
  }
`;
const ModalBox = styled.div`
  position: absolute;
  top: 25%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: ${({
  theme
}) => theme.colors.WHITE};
  min-width: ${({
  $minWidth
}) => `${$minWidth}`};
  min-height: ${({
  $minHeight
}) => `${$minHeight}`};
  max-height: calc(100vh - 40px);
  overflow: auto;
  padding: ${({
  $fullSpaceModal
}) => $fullSpaceModal ? "0" : "30px"};

  ${({
  $fullSpaceModal
}) => $fullSpaceModal && `
    top: 50%;
    overflow: hidden;
  `}

  ${({
  theme
}) => theme.mediaQueries.sm} {
    top: auto !important;
    bottom: -25px !important;
    width: 100% !important;
    left: 0 !important;
    border-radius: 25px;

    ${({
  $fullPageMobile,
  $fullSpaceModal
}) => !$fullPageMobile ? `
    width: calc(100% - 40px);
    min-width: calc(100% - 40px);
    max-height: calc(100% - 40px);
    top: 20px;
    left: 20px;
    transform: none;
    overflow: auto;
    padding: ${$fullSpaceModal ? "0" : "10px 20px 20px 20px"};
    ` : `
      border-radius: 0;
    `}
  }
`;
export default ModalComponent;